import { LogLevelField } from "./LogLevelField";
import { MoreParameters } from "./MoreParameters";
import styles from "./parameterForms.module.css";
import { declaredDefault } from "./parameterValues";
import { ResizeImagesSlider } from "./ResizeImagesSlider";
import { SegmentedParameter } from "./SegmentedParameter";
import { SwitchParameter } from "./SwitchParameter";
import { TagOnSuccessField } from "./TextParameter";
import { TopicsControl } from "./TopicsControl";
import { type ParameterFormProps } from "./types";

const COVERED_KEYS = [
  "INCLUDE_TOPICS",
  "EXCLUDE_TOPICS",
  "IMAGE_FORMAT",
  "RESIZE_IMAGES",
  "ENABLE_DOCTOR",
  "INGESTED_TAG",
  "LOG_LEVEL",
] as const;

/** `ros_ingestion` adds TRACE, which also turns on its libraries' logs. */
const LOG_LEVELS = ["TRACE", "DEBUG", "INFO", "WARNING", "ERROR"] as const;

/** `ros_ingestion`: ROS bags and MCAP files. */
export function RosIngestionForm(props: ParameterFormProps) {
  const { name, action } = props;
  return (
    <div className={styles.form} data-testid="parameter-form-ros_ingestion">
      <TopicsControl
        name={name}
        includeKey="INCLUDE_TOPICS"
        excludeKey="EXCLUDE_TOPICS"
      />
      <SegmentedParameter
        name={name}
        parameterKey="IMAGE_FORMAT"
        title="Image format"
        options={[
          { value: "jpeg", label: "JPEG", aliases: ["jpg"] },
          { value: "png", label: "PNG" },
        ]}
        defaultValue={declaredDefault(action, "IMAGE_FORMAT", "jpeg") ?? "jpeg"}
      />
      <ResizeImagesSlider
        name={name}
        defaultScale={declaredDefault(action, "RESIZE_IMAGES", "0.7") ?? "0.7"}
      />
      <SwitchParameter
        name={name}
        parameterKey="ENABLE_DOCTOR"
        label="Repair damaged MCAP files"
        description="Turning it off is faster, but damaged files may fail to ingest."
        defaultOn={
          (
            declaredDefault(action, "ENABLE_DOCTOR", "true") ?? "true"
          ).toLowerCase() === "true"
        }
        spelling="lower"
      />
      <TagOnSuccessField
        name={name}
        defaultTag={declaredDefault(action, "INGESTED_TAG", "ros")}
      />
      <MoreParameters
        {...props}
        coveredKeys={COVERED_KEYS}
        disclosedKeys={["LOG_LEVEL"]}
      >
        <LogLevelField
          name={name}
          levels={LOG_LEVELS}
          defaultLevel={declaredDefault(action, "LOG_LEVEL", "INFO") ?? "INFO"}
        />
      </MoreParameters>
    </div>
  );
}
